import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';
import { getLocaleString } from '../../../locale';

const STALE_TIME = 60 * 60 * 1000;
const GC_TIME = 2 * 60 * 60 * 1000;

export const useDocLibraryProducts = () => {
    const { i18n: { language } } = useTranslation();

    const { data, isLoading } = useGetCustomService({
        service: 'customCommonService',
        api: 'getProductsConfiguration',
        payload: { language },
        enabled: true,
        staleTime: STALE_TIME,
        gcTime: GC_TIME,
    });

    const responseData = data as { data?: { productOffers?: Array<{ products: Array<{ id: string | number; name: unknown }> }> } } | null;

    // Memoized so consumers can safely use the list as a hook dependency.
    const productList = useMemo(
        () => (responseData?.data?.productOffers?.[0]?.products ?? []).map(
            (item) => ({
                id: String(item.id),
                label: getLocaleString(item.name, language),
            }),
        ),
        [responseData?.data?.productOffers, language],
    );

    return { data: productList, isLoading };
};
